import React, { useState, useEffect } from 'react';
import {
  List,
  TextField,
  Button,
  Checkbox,
  Grid,
  Typography,
  Link,
  Autocomplete,
} from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';
import api from 'services/api';
import { useStyles } from 'components/Styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import NumberFormat from 'react-number-format';
import { labelField } from 'utils';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function HandleSupplies(data) {
  const [supplies, setSupplies] = useState([]);
  const [newSupply, setNewSupply] = useState({
    id: null,
    quantity: null,
    stock: { unity: { sigla: '' } },
  });
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [openDeleteSuplies, setOpenDeleteSuplies] = useState(false);
  const [newSupplyIsNull, setNewSupplyIsNull] = useState(false);
  const [unities, setUnities] = useState([]);
  const [options, setOptions] = useState([]);
  const [check, setCheck] = useState(false);
  const [iteracao, setIteracao] = useState(0);
  const classes = useStyles();
  // const [, updateState] = useState();
  // const forceUpdate = useCallback(() => updateState({}), []);
  const { id } = useParams();
  const history = useHistory();

  const [open, toggleOpen] = React.useState(false);

  useEffect(() => {
    setIteracao(iteracao + 1);
    if (options.length === 0 && iteracao > 1) data.suppliesIsNull[1](true);
  }, [options]);

  useEffect(() => {
    if (options.length !== 0) data.suppliesIsNull[1](false);
  }, [newSupply]);

  useEffect(() => {
    api.get('/supplies').then((supply_) => {
      //
      // setSupplies(supply_.data.map((s) => ({supply: s})));
      setSupplies(supply_.data.filter((s) => s.isStocked));
      //
    });
    api.get('/unities').then((unities_) => setUnities(unities_.data));
  }, []);

  const handleClose = () => {
    toggleOpen(false);
  };

  useEffect(() => {
    if (newSupply.quantity !== undefined) setNewSupplyIsNull(false);
    if (newSupply.quantity <= newSupply.stock?.quantity) { setNewSupplyIsNull(false); }
  }, [newSupply.quantity]);

  const handleSubmit = (event) => {
    if (newSupply.quantity === 0) {
      setNewSupplyIsNull(true);
      return false;
    }
    if (newSupply.quantity > newSupply.stock?.quantity) {
      setNewSupplyIsNull(true);
      return false;
    }
    addOption();
    handleClose();
  };

  useEffect(() => {
    setOptions(data.options);
  }, [data.options]);

  // Função que adiciona um objeto suprimento em entradas
  async function addOption() {
    const pivot = options;
    pivot.push(newSupply);
    setNewSupply({
      id: null,
      quantity: null,
      supply_id: null,
      supply: { stock: { unity: { sigla: '' } } },
    });
    setOptions(pivot);
  }

  const deleteSupply = (supply_id) => {
    api
      .delete(`/inputs/${id}/supplies/${supply_id}`)
      .then((response) => {

      })
      .catch((error) => {

      });
  };

  const handleCloseDeleteSuplies = () => {
    setOpenDeleteSuplies(false);
  };

  // Função que deleta o objeto suprimento escolhido
  function handleDeleteSuplies() {
    const currentOptions = [...options];
    const optionsToRemove = options.filter((o) => selectedOptions.every((opt) => o.supply_id !== opt.supply_id));

    optionsToRemove.forEach((o) => {
      const index = currentOptions.findIndex((opt) => opt.supply_id === o.supply_id);
      deleteSupply(currentOptions[index].supply_id);
      currentOptions.splice(index, 1);
    });

    setOptions(currentOptions);
    data.callback(currentOptions);
    setOpenDeleteSuplies(false);
  }

  // Funções que gerenciam a visulização do nome do suprimento em função do id
  // function handleNewSupply(event) {
  //
  //   setNewSupplyId(event.props.value);
  //   handleNewSupllyName(event.props.value);
  // }

  // function handleNewSupllyName(id) {
  //   supplies.map((supply) => {
  //     if (supply.id === id) {
  //       setNewSupplyName(supply.name);
  //       setNewUnity(supply.unity);
  //     }
  //     return null;
  //   });
  // }

  // Função que seta a unidade de saída no devido campo

  // function handleOutputUnity(unit) {
  //
  //   let unidade = unit[0].output;
  //
  //   //setNewUnity(unidade[0].name+" ("+unidade[0].sigla+")");
  //   setNewUnity(unidade);
  //
  // }

  return (
    <List dense align="center">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={() => handleSubmit()}>
          <DialogTitle id="form-dialog-title">
            Adicionar novo insumo
          </DialogTitle>
          <DialogContent>
            <DialogContentText />
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4}>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  disabled
                  value={newSupply.name}
                  label="Insumo"
                  type="text"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <NumberFormat
                  autoFocus
                  required
                  variant="outlined"
                  margin="dense"
                  id="quantity"
                  label="Quantidade"
                  name="quantity"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={4}
                  isAllowed={(inputObj) => inputObj.value <= 1000000}
                  allowNegative={false}
                  value={newSupply.quantity}
                  onValueChange={(input) => {
                    setNewSupply({ ...newSupply, quantity: input.floatValue });
                  }}
                  customInput={TextField}
                  error={
                    newSupply.quantity <= 0
                    || newSupply.quantity > newSupply.stock?.quantity
                    || newSupplyIsNull
                  }
                  helperText={
                    (newSupply.quantity > newSupply.stock?.quantity
                      && 'A quantidade é maior que a disponivel')
                    || (newSupply.quantity <= 0
                      && 'É necessário inserir uma quantidade maior que zero')
                    || (newSupplyIsNull && 'Campo Obrigatório')
                  }
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                {/* <Autocomplete
                  noOptionsText="Sem unidade cadastrada"
                  disabled
                  name="unity"
                  options={unities}
                  value={newSupply.unity}
                  getOptionLabel={(option) => option.sigla}
                  fullWidth
                  onChange={(p, v) => {
                    setNewUnity(v);
                  }}
                  renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Unidade"
                        margin="dense"
                        variant='outlined'
                    />
                  )}
                /> */}
                <TextField
                  disabled
                  label="Unidade"
                  value={newSupply.stock?.unity.name}
                  margin="dense"
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: '2rem' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              style={{
                border: '1px solid red',
                color: 'red',
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => handleSubmit()}
              style={{
                backgroundColor: '#0267C1',
                color: 'white',
              }}
            >
              Adicionar
            </Button>
          </DialogActions>
          {/* <DialogActions>
            <Button
              onClick={handleClose}
              style={{
                color: "white",
                backgroundColor: "red",
                borderRadius: "15px",
              }}
            >
              Cancelar
            </Button>
            <Button
              style={{
                borderRadius: "15px",
              }}
              color="primary"
              onClick={() => handleSubmit()}
            >
              Adicionar
            </Button>
          </DialogActions> */}
        </form>
      </Dialog>

      <Autocomplete
        id="combo-box-demo"
        noOptionsText={(
          <Typography>
            Nenhum insumo cadastrado na fazenda.
            <Link
              style={{ marginLeft: '1%', cursor: 'pointer' }}
              color="primary"
              onMouseDown={() => {
                history.push('/supply');
              }}
            >
              Cadastrar agora +
            </Link>
          </Typography>
        )}
        multiple
        disableCloseOnSelect
        value={options}
        options={supplies}
        getOptionLabel={(option) => (
          ` + ${option.quantity
          } ${option.stock
            ? option.stock?.unity.sigla
            : option.supply?.stock?.unity.sigla
          } de ${option.supply ? option.supply.name : option.name}`
        )}
        isOptionEqualToValue={(option, value) => value?.id === option.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label={labelField('Insumos')}
            variant="outlined"
            fullWidth
            error={data.suppliesIsNull[0]}
            helperText={data.suppliesIsNull[0] && 'Campo Obrigatório'}
          />
        )}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
              color="primary"
            />
            {option.name}
            , (
            {option.stock.quantity}
            {' '}
            {option.stock.unity.sigla}
            )
          </li>
        )}
        onChange={(event, selectedOptions, r) => {
          setSelectedOptions(selectedOptions);
          if (r === 'removeOption') {
            setOpenDeleteSuplies(true);
          } else if (selectedOptions.length > 0) {
            const selected = selectedOptions[selectedOptions.length - 1];
            setNewSupply({ ...selected, supply_id: selected.id });
            toggleOpen(true);
          } else {
            setOptions([]);
            data.callback([]);
          }
        }}
      />

      <Dialog
        open={openDeleteSuplies}
        onClose={handleCloseDeleteSuplies}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Deseja realmente excluir esse insumo?
        </DialogTitle>
        <DialogActions style={{ padding: '1rem' }}>
          <Button
            variant="outlined"
            onClick={handleCloseDeleteSuplies}
            style={{
              border: '1px solid red',
              color: 'red',
            }}
          >
            Não
          </Button>
          <Button
            onClick={handleDeleteSuplies}
            style={{
              backgroundColor: '#0267C1',
              color: 'white',
            }}
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </List>
  );
}
